import * as _courseOutlineConfig from 'legacy/src/utility/CourseOutlineConfig/state/action';

export const courseOutlineConfig = _courseOutlineConfig;
